import React from 'react';
import PropTypes from 'prop-types';
import Storeys from '../../../../../classes/common/storeys';

function Floor (props) {
  const item = props.item;
  const property = item.getProperty();
  const room = property.getRoom();
  const building = property.getBuilding();

  const floor = room.getFloorNumber();
  const totalFloors = building.getFloorsNumberAboveGround();
  const storeys = new Storeys(floor, totalFloors);

  return (
    <td className='paper col-floor'>
      {
        (floor || totalFloors)
        ? (<div><span className='main-param'>{storeys.getLabel(Storeys.TYPE_SMALL)}</span></div>)
        : (<div><span className='main-param'>-/-</span></div>)
      }
    </td>
  );
}

Floor.propTypes = {
  item: PropTypes.object.isRequired
};

Floor.defaultProps = {};

export default Floor;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/Cells/PaperCells/Floor.jsx